import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { addDate, formatDate, getEndOfMonth, getEndOfWeek, getStartOfMonth, getStartOfWeek, inRange, isSameDay, isValid, getWeekStart, getWeekEnd } from '@jd/jmtd-tools/es/date';
import { isFunction } from '@jd/jmtd-tools/es/is';
export function formatDay(d) {
  return formatDate(d, 'YYYY-MM-DD');
}
export function fixZero(d) {
  return Number(d) >= 10 ? d : "0".concat(Number(d));
}
export { getWeekStart, getWeekEnd };

var isValidDate = function isValidDate(date) {
  return date instanceof Date && !Number.isNaN(date.getTime());
};
/**
 * 获取给定所有日期中最小的日期
 *
 * @export
 * @param {Date} dates
 * @returns {Date} minDate
 */


export function minDate() {
  var result;

  for (var _len = arguments.length, dates = new Array(_len), _key = 0; _key < _len; _key++) {
    dates[_key] = arguments[_key];
  }

  dates.forEach(function (date) {
    if (!isValidDate(date)) return;
    if (!result || result > date) result = date;
  });
  return result;
}
/**
 * 获取给定所有日期中最大的日期
 *
 * @export
 * @param {Date} dates
 * @returns {Date} maxDate
 */

export function maxDate() {
  var result;

  for (var _len2 = arguments.length, dates = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    dates[_key2] = arguments[_key2];
  }

  dates.forEach(function (date) {
    if (!isValidDate(date)) return;
    if (!result || result < date) result = date;
  });
  return result;
}
/**
 * 将字符串首字母大写
 *
 * @export
 * @param {string} str
 * @returns
 */

export function upperCaseFirstLetter(str) {
  return str.slice(0, 1).toUpperCase() + str.slice(1);
}
/**
 * 将一维数组转换为二维数组
 *
 * @export
 * @param {array} arr 要转换的数组
 * @param {number} row 每行的元素个数
 * @author Sven
 * @example convertDyadicArray([2,3,4,5,6,7], 3) => [[2,3,4],[5,6,7]]
 */

export function convertDyadicArray(arr, row) {
  var dyadicArray = [];
  var col = arr.length / row;

  for (var i = 0; i < col; i++) {
    dyadicArray.push(arr.slice(i * row, (i + 1) * row));
  }

  return dyadicArray;
}
/**
 * 根据指定日期范围生成DateItem数组
 *
 * @export
 * @param {Date} originStartDate 起始日期
 * @param {Date} originEndDate 结束日期
 * @param {'day'|'month'} [interval='day'] 生成DateItem的时间间隔单位，取值'day'|‘month’
 * @returns {Date[]} 生成的DateItem数组
 */

export function getDateItemsByRange(startDate, endDate) {
  var interval = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'day';

  if (!(isValid(startDate) && isValid(endDate))) {
    console.error('Invalid date range.');
    return [];
  }

  switch (interval) {
    case 'month':
      {
        var monthRange = endDate.getFullYear() * 12 + endDate.getMonth() - (startDate.getFullYear() * 12 + startDate.getMonth());
        return Array.from({
          length: monthRange
        }, function (_v, i) {
          return addDate(i, 'month');
        });
      }

    case 'day':
    default:
      {
        var dayInMilliseconds = 24 * 60 * 60 * 1000; // 一天的毫秒数
        // 将起止日期的时分秒归零，并取其时间戳格式

        var formattedStartTimestamp = startDate.setHours(0, 0, 0, 0);
        var formattedEndTimestamp = endDate.setHours(0, 0, 0, 0);
        var dayRange = Math.floor((formattedEndTimestamp - formattedStartTimestamp) / dayInMilliseconds) + 1;
        return Array.from({
          length: dayRange
        }, function (_v, i) {
          return new Date(startDate.getTime() + dayInMilliseconds * i);
        });
      }
  }
}
/**
 * 根据指定年月获取日期面板所需要渲染的日期范围，包括前后补足整周的上下月日期
 *
 * @export
 * @param {Date} date 表示日期面板当前年月的GraceDate对象
 * @param {number} firstDayOfWeek 周起始日，0-6分别表示周日至周六
 * @returns {Date[]} [startDate, endDate]
 */

export function getDayPanelDateRange(date, firstDayOfWeek) {
  var startDate = getStartOfWeek(getStartOfMonth(date), firstDayOfWeek);
  var endDate = getEndOfWeek(getEndOfMonth(date), firstDayOfWeek); // 日期面板只负责日期选择，将时分秒全部置为0

  startDate.setHours(0, 0, 0, 0);
  endDate.setHours(0, 0, 0, 0);
  return [startDate, endDate];
}
/**
 * 根据指定年月获取日期面板所需要渲染的所有日期项
 *
 * @export
 * @param {Date} date 表示日期面板当前年月的GraceDate对象
 * @param {number} firstDayOfWeek 周起始日，0-6分别表示周日至周六
 * @returns {Date[]} 当前面板的日期项
 */

export function getDayPanelDateItems(date, firstDayOfWeek) {
  var _getDayPanelDateRange = getDayPanelDateRange(date, firstDayOfWeek),
      _getDayPanelDateRange2 = _slicedToArray(_getDayPanelDateRange, 2),
      panelStartDate = _getDayPanelDateRange2[0],
      panelEndDate = _getDayPanelDateRange2[1];

  var dateItems = getDateItemsByRange(panelStartDate, panelEndDate);

  var diffInMonth = function diffInMonth(startDate, endDate) {
    return endDate.getFullYear() * 12 + endDate.getMonth() - (startDate.getFullYear() * 12 + startDate.getMonth());
  };

  dateItems.forEach(function (dateItem) {
    if (diffInMonth(date, dateItem.date) === -1) dateItem.addClassName('grace-datepicker-date-cell-prev-month');else if (diffInMonth(date, dateItem.date) === 1) dateItem.addClassName('grace-datepicker-date-cell-next-month');
  });
  return dateItems;
}
/**
 * 根据指定年获取月面板所需要渲染的所有日期项
 *
 * @export
 * @param {Date} date 表示月面板当前年的GraceDateDate对象
 * @returns {Date[]} 当前面板的日期项
 */

export function getMonthPanelDateItems(date) {
  var year = date.getFullYear();
  return Array.from({
    length: 12
  }, function (v, i) {
    return new Date(new Date(year, i, 1, 0, 0, 0));
  });
}
export function getQuarterPanelDateItems(date) {
  var year = date.getFullYear();
  return Array.from({
    length: 4
  }, function (v, i) {
    return new Date(new Date(year, i ? i * 3 : i, 1, 0, 0, 0));
  });
}
export function getYearPanelDateItems(date) {
  var year = date.getFullYear();
  var index = year % 12;
  return Array.from({
    length: 12
  }, function (v, i) {
    return new Date(year + i - index, 0, 1, 0, 0, 0);
  });
}
export function getYearPanelRange(date) {
  var year = date.getFullYear();
  var index = year % 12;
  return [year - index, year - index + 11];
}
export function dateSelectedState(dateItem, selectedDate, panelDate) {
  if (selectedDate) {
    selectedDate.sort(function (l, r) {
      return l - r;
    });

    var _selectedDate = _slicedToArray(selectedDate, 2),
        start = _selectedDate[0],
        end = _selectedDate[1];

    return {
      'jmtd-date-picker-cell-start': isSameDay(dateItem, start),
      'jmtd-date-picker-cell-end': isSameDay(dateItem, end),
      'jmtd-date-picker-cell-selected': inRange(dateItem, start, end) && (!panelDate || inRange(dateItem, getStartOfMonth(panelDate), getEndOfMonth(panelDate))),
      // 是否选中，在区域中
      'jmtd-date-picker-cell-between': !isSameDay(dateItem, start) && !isSameDay(dateItem, end) // 端点

    };
  }

  return {};
}
export function parsePanelConfig(panelConfig, panelDate) {
  return panelConfig ? isFunction(panelConfig) ? panelConfig(panelDate) : panelConfig : {};
}
export function today() {
  var now = new Date();
  return new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0, 0);
}